import { render, staticRenderFns } from "./LoginCheck.vue?vue&type=template&id=23407afa"
import script from "./LoginCheck.vue?vue&type=script&lang=js"
export * from "./LoginCheck.vue?vue&type=script&lang=js"
import style0 from "./LoginCheck.vue?vue&type=style&index=0&id=23407afa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports